import React from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import { Box, Typography, MenuItem, TextField, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { CustomButton } from '../../../../../components/Button/Button';
import { RFHdatePicker, RFHTextField, RHFSelect } from '../../../../../components/RFH';

const optionFieldTypes = ['multi_choice', 'checkbox', 'select'];

const ManageFieldsLeft = ({ methods, label, fieldType, FIELD_TYPES, fields, isLoading }) => {
    const { control, watch } = methods;
    const selectedType = watch('field_type');

    const { fields: optionFields, append, remove } = useFieldArray({
        control,
        name: 'settings',
    });

    const getSequenceOptions = () => {
        const options = [{ value: '', label: 'Select Position' }];
        fields?.forEach((field, index) => {
            index === 0 ? options.push(
                { value: `1_before_${field.name}`, label: `Before ${field.name}` },
                { value: `2_after_${field.name}`, label: `After ${field.name}` }
            ) : index === 1 ? options.push(
                { value: `2_before_${field.name}`, label: `Before ${field.name}` },
                { value: `3_after_${field.name}`, label: `After ${field.name}` }
            ) : options.push(
                { value: `${index}_before_${field.name}`, label: `Before ${field.name}` },
                { value: `${index + 2}_after_${field.name}`, label: `After ${field.name}` }
            );
        });
        return options;
    };

    return (
        <Box className="manage-fields-left">
            <Typography variant="subtitle1" fontWeight={700} className="manage-fields-title">
                Create a field
            </Typography>
            <Typography variant="body2" color="text.secondary" className="manage-fields-desc">
                Add custom fields to capture the exact details your team needs for each task.
            </Typography>
            <RFHTextField
                name="display_name"
                label="Label"
                className="custom_label_text_field"
                inputProps={{ maxLength: 25 }}
            />
            <RHFSelect name="field_type" label="Field Type" className="custom_fieldtype_select">
                {FIELD_TYPES.map((option) => (
                    <MenuItem key={option.value} value={option.value} disabled={option.value === ''}>
                        {option.label}
                    </MenuItem>
                ))}
            </RHFSelect>
            <RHFSelect name="sequence" label="Insert At Position" className="custom_fieldtype_select">
                {getSequenceOptions().map((option) => (
                    <MenuItem key={option.value} value={option.value} disabled={option.value === ''}>
                        {option.label}
                    </MenuItem>
                ))}
            </RHFSelect>
            {optionFieldTypes.includes(selectedType) && (
                <Box sx={{ width: '100%' }}>
                    <Typography variant="body2" sx={{ mb: 1, mt: 1, fontWeight: 500 }}>
                        Options
                    </Typography>
                    {optionFields.map((option, idx) => (
                        <Box key={option.id} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <RFHTextField
                                name={`settings.${idx}.value`}
                                placeholder={`Option ${idx + 1}`}
                                className="custom_option_text_field"
                                autoFocus
                                inputProps={{ maxLength: 25 }} />
                            <IconButton
                                aria-label="Remove option"
                                onClick={() => remove(idx)}
                                size="small"
                                sx={{ ml: 1 }}
                                disabled={optionFields.length === 1}
                            >
                                <RemoveIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    ))}
                    {methods.formState.errors?.settings?.message && <span className='error_message'>{methods.formState.errors?.settings?.message}</span>}
                    <CustomButton
                        variant="outlined"
                        size="small"
                        onClick={() => append({ value: '' })}
                        sx={{ mt: 1, mb: 1 }}
                        className="manage-fields-add-option-btn"
                    >
                        <AddIcon fontSize="small" /> Add Option
                    </CustomButton>
                </Box>
            )}

            <CustomButton
                type="submit"
                variant="contained"
                color="primary"
                disabled={!label || !fieldType || isLoading}
                className="manage-fields-add-btn"
            >
                Add
            </CustomButton>
        </Box>
    );
};

export default ManageFieldsLeft; 